const ZIGZAG_LINE =
  "0,14 90,40 180,16 270,44 360,10 450,46 540,12 630,42 720,10 810,48 900,14 990,40 1080,8 1170,46 1260,12 1350,42 1440,18";

const ZigzagDivider = ({ fill = "#142a34", flip = false, className = "" }) => (
  <div className={className} aria-hidden="true">
    <svg
      viewBox="0 0 1440 60"
      preserveAspectRatio="none"
      className="block h-10 w-full md:h-14"
      style={flip ? { transform: "scaleY(-1)" } : undefined}
    >
      <polygon points={`0,0 1440,0 1440,18 1350,42 1260,12 1170,46 1080,8 990,40 900,14 810,48 720,10 630,42 540,12 450,46 360,10 270,44 180,16 90,40 0,14`} fill={fill} />
      <polyline
        points={ZIGZAG_LINE}
        fill="none"
        stroke="#c8925a"
        strokeWidth="2"
        strokeLinejoin="round"
        className="zigzag-pulse"
      />
    </svg>
  </div>
);

export default ZigzagDivider;
